<app-top-navigation></app-top-navigation>

<section class="home-bg relative text-left">
  <div class="container">
    <div class="centered-element">
      <div class="row">
        <div class="medium-12 columns">
          <div class="mega-text margin-bottom-05 uppercase gotham">Enterprise Solution</div>
          <div class="huge-text gotham thin-font">
            Seri khusus enterprise. Ciptakan video lebih profesional dan efisiensi lapangan dari
            berbagai sektor bisnis
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="catalog_nav_container show-for-medium black-color">
  <div class="row">
    <div class="medium-12 columns">
      <div
        class="flex-container catalog_nav gotham"
        style="align-items: center; justify-content: center">
        <div
          (click)="navigateTo(item)"
          *ngFor="let item of catalog_nav"
          class="flex-item catalog_nav_item cursor text-center">
          <!-- <div>
                        <img width="60" height="60" [src]="item.icon" alt="">
                    </div> -->
          <div class="small-text">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="flex-container catalog_nav_container scroll-container chips-container show-for-small-only">
  <div
    (click)="navigateTo(item)"
    *ngFor="let item of catalog_nav"
    class="flex-item scroll-item-35 gotham ng-star-inserted padding-bottom-1">
    <div
      class="button clear black-color"
      style="background: transparent !important">
      <div class="small-text">
        {{ item.label }}
      </div>
    </div>
  </div>
</div>

<div class="padding-center black-color gotham">
  <div class="row">
    <div class="medium-12 columns">
      <div
        *ngIf="active_nav"
        class="padding-bottom-1">
        <h1>{{ this.active_nav.label }}</h1>
      </div>

      <div class="row medium-up-4 small-up-2">
        <div
          *ngFor="let item of products"
          class="columns">
          <div
            (click)="selectItem(item)"
            class="product-item-container cursor text-center">
            <div
              *ngIf="item.is_in_stock"
              class="status">
              Ready
            </div>
            <div class="margin-bottom-1">
              <img
                [src]="item.product_cover"
                alt="" />
              <div class="title">
                {{ item.name }}
              </div>
              <div
                *ngIf="item.special_price >= item.price"
                class="price">
                {{ item.price | currency: "Rp" }}
              </div>
              <div
                *ngIf="item.special_price < item.price"
                class="price">
                <div
                  class="price"
                  style="text-decoration: line-through">
                  {{ item.price | currency: "Rp" }}
                </div>
                {{ item.special_price | currency: "Rp" }}
              </div>
            </div>

            <button class="button small expanded">Pesan Online</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal
  (onClose)="selected_item = null"
  *ngIf="selected_item"
  title="Pesan">
  <div class="margin-bottom-1 black-color gotham">
    <img
      style="background: white; border-radius: 14px"
      class="margin-bottom-05"
      [src]="selected_item.product_cover"
      alt="" />
    <div class="large-text">
      {{ selected_item.name }}
    </div>
    <div
      class="small-text"
      *ngIf="selected_item.long_description">
      {{ selected_item.long_description }}
    </div>

    <div
      *ngIf="selected_item.special_price >= selected_item.price"
      class="price">
      {{ selected_item.price | currency: "Rp" }}
    </div>
    <div
      *ngIf="selected_item.special_price < selected_item.price"
      class="price">
      <div
        class="price"
        style="text-decoration: line-through">
        {{ selected_item.price | currency: "Rp" }}
      </div>
      {{ selected_item.special_price | currency: "Rp" }}
    </div>
  </div>
  <div class="list-tile-container black-color">
    <div class="list-tile-item">
      <div class="flex-container align-center">
        <div class="flex-item flex-1 large-text">Tokopedia</div>
        <div class="flex-item">
          <a
            target="_blank"
            href="https://tokopedia.link/UCrW0ZvPQMb"
            class="tiny rounded button">
            Pesan
          </a>
        </div>
      </div>
    </div>
    <div class="list-tile-item">
      <div class="flex-container align-center">
        <div class="flex-item flex-1 large-text">Shopee</div>
        <div class="flex-item">
          <a
            target="_blank"
            href="https://shopee.co.id/djiauthorized?uls_trackid=50og6ars00b0&utm_content=2jPjERXaYwmgx5jeykotrxjnd8h5"
            class="tiny rounded button">
            Pesan
          </a>
        </div>
      </div>
    </div>
    <div class="list-tile-item">
      <div class="flex-container align-center">
        <div class="flex-item flex-1 large-text">WhatsApp</div>
        <div class="flex-item">
          <a
            target="_blank"
            href="https://wa.me/+6281533178887?text=Halo%20DJI%20Indonesia,%20mohon%20bantuannya"
            class="tiny rounded button">
            Pesan
          </a>
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-section-footer></app-section-footer>
